module.exports = __webpack_public_path__ + "static/media/26UNRWA18.2e63f06c.jpg";